import { getModalStyle } from '@/utils/Modal';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import {
    Close as CloseIcon,
    Download as DownloadIcon
} from '@mui/icons-material';

export default function ImageViewer({open, url, title, disclaimer, download, downloadFile, external, fullScreen, handleClose}){
	
	const { sxDialogImageViewer, sxDialogContentFileViewer } = getModalStyle();

	return (
		<Dialog
            container={fullScreen?.active ? fullScreen?.node?.current : null}
            sx={sxDialogImageViewer}
            onClose={handleClose}
            open={open}
            //fullWidth={true}
            maxWidth='lg'
        >
        	{
        		title && title?.length > 0 &&
				<DialogTitle className='modal-title w-full truncate'>
		            {title}
		        </DialogTitle>
		    }
	        <DialogContent sx={sxDialogContentFileViewer}> 
	        		<div className='flex flex-col items-center justify-center'>    
		        		{
		        			disclaimer && disclaimer?.length > 0 &&
			                <div 
			                    className='app-color mb-2 my-2' 
			                    dangerouslySetInnerHTML={{__html: disclaimer}}
			                ></div>
			            }
		                <div className='p-2'>
		                	{
		                		external ? 
		                			<a href={url} target='_blank'>
		                				<img src={url} className=''/>
		                			</a>
		                		:
		                			<img src={url} className=''/>
		                	}
		                </div>                    
		            </div>
	        </DialogContent>            
	        <div className="modal-buttons">	            
	            {
	                download &&
	                <div className='me-1'>
	                    <DownloadIcon className='action-button-modal app-color' onClick={downloadFile}/>
	                </div>
	            }
	            <div className=''>
	                <CloseIcon className='action-button-modal text-black' onClick={handleClose}/>
	            </div>
	        </div>
        </Dialog>
    );
}